export default "__VITE_ASSET__318a6aff__"